import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from 'src/app/core/services/api/api.service';
import { api } from 'src/app/models/api-url.model';
import {
  IqDashboardResponse,
  IqTicketStats,
} from '../domain/iq-aggregated-dashboard.model';

@Injectable({ providedIn: 'root' })
export class IqAggregatedDashboardService {
  private readonly apiService = inject(ApiService);

  getIqObservationsDashboard(
    beginDatetime: string,
    endDatetime: string,
    showMockData: boolean = false,
  ): Observable<IqDashboardResponse | null> {
    const params = new HttpParams()
      .set('beginDatetime', beginDatetime)
      .set('endDatetime', endDatetime)
      .set('showMockData', showMockData);

    return this.apiService
      .get<IqDashboardResponse>(api.getIqDashboard, { params })
      .pipe(map((response) => response ?? null));
  }

  getAggregatedIqTicketStats(
    beginDatetime: string,
    endDatetime: string,
    showMockData: boolean = false,
  ): Observable<IqTicketStats | null> {
    const params = new HttpParams()
      .set('beginDatetime', beginDatetime)
      .set('endDatetime', endDatetime)
      .set('showMockData', showMockData);

    return this.apiService
      .get<IqTicketStats>(api.getIqTicketStats, { params })
      .pipe(map((response) => response ?? null));
  }
}
